import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
export function StickyBottomBar() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      const scrolledPastHero = window.scrollY > 600;
      const ctaSection = document.getElementById('cta');
      let ctaInView = false;
      if (ctaSection) {
        const rect = ctaSection.getBoundingClientRect();
        ctaInView = rect.top < window.innerHeight;
      }
      setIsVisible(scrolledPastHero && !ctaInView);
    };
    window.addEventListener('scroll', handleScroll);
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <AnimatePresence data-id="element-103">
      {isVisible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 30
    }} className="fixed bottom-0 left-0 right-0 z-40 bg-white/95 backdrop-blur-md border-t-2 border-[#1B4B5A] py-4 px-6 shadow-[0_-10px_30px_rgba(0,0,0,0.05)]" data-id="element-104">
          <div className="max-w-4xl mx-auto flex items-center justify-between gap-4 font-sans" data-id="element-105">
            <div className="hidden sm:block" data-id="element-106">
              <p className="text-[#2C2C2C] font-bold text-lg" data-id="element-107">
                Rescate de Pareja
              </p>
              <p className="text-[#1B4B5A] font-bold text-xl" data-id="element-108">$4.929 ARS</p>
            </div>
            <div className="sm:hidden text-[#1B4B5A] font-bold text-xl" data-id="element-109">
              $4.929
            </div>

            <motion.a href="#cta" whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} animate={{
          boxShadow: ['0 0 0 0 rgba(194, 113, 79, 0)', '0 0 0 10px rgba(194, 113, 79, 0.2)', '0 0 0 0 rgba(194, 113, 79, 0)']
        }} transition={{
          duration: 2.5,
          repeat: Infinity,
          repeatType: 'reverse'
        }} className="bg-[#4fc251] text-white px-6 py-3 rounded-lg text-lg font-semibold shadow-[0_5px_15px_-3px_rgba(194,113,79,0.4)] hover:bg-[#A85D3F] transition-colors whitespace-nowrap tracking-wide" data-id="element-110">
              Descargar el sistema
            </motion.a>
          </div>
        </motion.div>}
    </AnimatePresence>;
}